import {ConclusionKeys, FindingAreasEnum, QuestionnaireFlowType, getFindingAreaDisplayText, zodQuestionTypes } from "../surveyStatusSchemas";

const questionnaireFollowUp: QuestionnaireFlowType = {
    id: FindingAreasEnum.FollowUp,
    name: getFindingAreaDisplayText(FindingAreasEnum.FollowUp),
    questions: [
        {
            id: `${FindingAreasEnum.FollowUp}:Q1`,
            text: "Are you subject to the Senior Accounting Officer regime?",
            type: zodQuestionTypes.enum.FreeText,
            flow: {
                next: `${FindingAreasEnum.FollowUp}:Q2`
            },
        },
        {
            id: `${FindingAreasEnum.FollowUp}:Q2`,
            text: "Do you operate any kind of Management Incentive Plan whereby employees or directors acquire shares or options? If so, please provide details.",
            type: zodQuestionTypes.enum.FreeText,
            flow: {
               next: ConclusionKeys.NotApplicable
            },
        },
        ]
}

export default questionnaireFollowUp;